<template>
  <div>
    <div v-if="successMessage" class="alert alert-success" role="alert">
      {{ successMessage }}
    </div>
    <form @submit.prevent>
      <div class="row">
        <div class="col-12">
          <fg-input type="number"
            max="500000"
            min="-500000"
            :placeholder="`Number of ${pool.license_type.product.name} licenses to credit`"
            :class="{ 'form-group--error': $v.amount.$error }"
            v-model="$v.amount.$model">
          </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
          <textarea placeholder="Notes"
            class="form-control"
            v-model="notes" />
          </div>
        </div>
      </div>
      <div class="text-left">
        <p-button type="info"
          :loading="isLoading"
          @click.native.prevent="creditLicenses">
          Confirm
        </p-button>
      </div>
      <div class="clearfix"></div>
    </form>
  </div>
</template>

<script>
import ziperase from '../../services/ziperase';
import { notify } from '../../services/notify';
import { between, integer, required } from 'vuelidate/lib/validators';

export default {
  name: 'CreditLicensesForm',
  props: {
    pool: Object
  },
  data() {
    return {
      amount: null,
      notes: "",
      isLoading: false,
      successMessage: ""
    }
  },
  validations: {
    amount: { required, between: between(-500000, 500000), integer }
  },
  methods: {
    async creditLicenses() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.amount.required || !this.$v.amount.integer) notify().error('Enter the number of licenses to credit.')
        if (!this.$v.amount.between) notify().error('Enter a number between 1 and 500000.')
        return;
      }

      this.isLoading = true;
      try {
        await ziperase.creditLicenses(this.pool.id, {
          count: this.amount,
          notes: this.notes
        });
        this.$emit('hasUpdate');
        this.$store.dispatch('licensePool/refetchTransactions');
        this.successMessage = `Success! Credited ${this.amount} licenses to the pool.`;
        this.resetForm();
      } catch (err) {
        notify().error('Failed to credit licenses.');
      }
      this.isLoading = false;
    },
    resetForm() {
      this.amount = null;
      this.notes = "",
      this.$v.$reset();
    }
  }
};
</script>
